import React from "react";
import styles from "./HotelImageSquare.module.scss";
import HotelIcon from '@material-ui/icons/Hotel';
import PlaceImageSquare, {IPlaceImageSquare} from "../placeImageSquare/PlaceImageSquare";


export interface IHotelImageSquare extends Omit<IPlaceImageSquare, 'icon'> {

}

const HotelImageSquare = (props: IHotelImageSquare) => (
  <PlaceImageSquare
    product={props.product}
    className={`HotelImageSquare ${props.className}`}
    iconContainerClassName={`${props.iconContainerClassName} ${styles.iconContainerClassName}`}
    icon={HotelIcon}
    label={props.label}
    logoSrc={props.logoSrc}
    logoTitle={props.logoTitle}
  />
);

HotelImageSquare.defaultProps = {
  className: ``,
  label: 'מלון',
};

export default HotelImageSquare;
